export default __webpack_public_path__ + "static/media/bape2.9f071dbb.jpg";